import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader, Tab, Responsive
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';

import StaffList from './CourseList';
import StaffTable from '../Util/StaffTable';


export default class ProfessorList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            staffList: { staffQuestionnaireDTOS: [] }

        };
    }
    componentDidMount() {
        localStorage.setItem('staffPosition', 'professor');
        axios.get(`questionnaire/staffDTO/statistics/${JSON.parse(localStorage.getItem('poll')).pollId}/profesor/`)
            .then(res => {
                const staffList = res.data;
                this.setState({ staffList, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });
    }


    render() {
        return (

            <Fragment>

                {this.state.loading ? <Loader active inline="centered" /> :
                    this.state.staffList.staffQuestionnaireDTOS.length ?

                        <StaffTable

                            staffList={this.state.staffList.staffQuestionnaireDTOS}
                        /> : 'Na odabranoj anketi nema profesora.'
                }


            </Fragment>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/QAPoll/ProfessorList.js